<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Price Justification</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">

        <div class="row">


            <div class="col-sm-12">
                <div class="form-group row text-left">
                    
                        <label for="lblBoRemarks" class="col-sm-6 col-form-label">Justification By Branch
                            <span class="font-red-flamingo">*</span></label>
                        <div class="col-sm-8">
                            <div class="input-group">

                                <textarea class="form-control h-150" matInput cdkTextareaAutosize maxlength="2000"
                                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
                                    [(ngModel)]="SpraPriceJustificationParams.BoRemarks"></textarea>

                            </div>

                        </div>
                    
                </div>
            </div>

            <div class="col-sm-12" *ngIf="SpraPriceJustificationParams.IsValidation">
                <div class="form-group row text-left">
                    <label for="lblHoRemarks" class="col-sm-6 col-form-label">Justification By HO
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        <textarea class="form-control h-50" matInput cdkTextareaAutosize maxlength="2000"
                            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
                            [(ngModel)]="SpraPriceJustificationParams.HoRemarks"></textarea>


                    </div>

                </div>
            </div>





        </div>


    </mat-card-content>
</mat-card>